// extracted by mini-css-extract-plugin
export default {"error-msg":"Error_error-msg__uCfVb"};